module.exports = __webpack_public_path__ + "img/VXPASS-Provider-Circle-Logo.8fb0bad3.png";